const UPDATE_LICENSE_URL = process.env.API_UNAUTH_URL + '/update-license';
const USER_LICENSE_URL = process.env.API_URL + '/user/license';
const SUBSCRIPTION_URL_V2 = process.env.API_URL + '/user/v2/subscription';

const updateUserLicense = (context, user) => {
  return new Promise((resolve, reject) => {
    context.$http.post(UPDATE_LICENSE_URL, user).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const updateLicense = (context, license) => {
  return new Promise((resolve, reject) => {
    context.$http.put(USER_LICENSE_URL, license).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const getSubscriptions = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(SUBSCRIPTION_URL_V2).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const getSubscriptionsOfUser = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(SUBSCRIPTION_URL_V2 + '/' + userId).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default {
  updateUserLicense,
  updateLicense,
  getSubscriptions,
  getSubscriptionsOfUser
};



// WEBPACK FOOTER //
// ./src/brand/health/api/updateLicense/index.js